/**
 * Thin wrapper around Tauri IPC.
 * All Tauri invoke calls go through this bridge so that:
 *   1. Web builds never import @tauri-apps/api (tree-shaken away)
 *   2. Future local-AI commands have a single entry point
 */

import { isDesktop } from './platform';

export async function invokeDesktop<T>(
  command: string,
  args?: Record<string, unknown>,
): Promise<T | null> {
  if (!isDesktop) return null;
  const { invoke } = await import('@tauri-apps/api/core');
  return invoke<T>(command, args);
}

export async function getAppVersion(): Promise<string | null> {
  return invokeDesktop<string>('get_app_version');
}

export async function getPlatform(): Promise<string | null> {
  return invokeDesktop<string>('get_platform');
}

export async function openExternalUrl(url: string): Promise<void> {
  if (!isDesktop) {
    window.open(url, '_blank');
    return;
  }
  const { invoke } = await import('@tauri-apps/api/core');
  await invoke('plugin:opener|open_url', { url });
}
